const TedNotificationIcon = () => (
  <div>
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="8" fill="#EFF8FF" />
      <path
        d="M18.0166 10.4248C15.2583 10.4248 13.0166 12.6665 13.0166 15.4248V17.8331C13.0166 18.3415 12.8 19.1165 12.5416 19.5498L11.5833 21.1415C10.9916 22.1248 11.4 23.2165 12.4833 23.5831C16.075 24.7831 19.95 24.7831 23.5416 23.5831C24.55 23.2498 24.9916 22.0581 24.4416 21.1415L23.4833 19.5498C23.2333 19.1165 23.0166 18.3415 23.0166 17.8331V15.4248C23.0166 12.6748 20.7666 10.4248 18.0166 10.4248Z"
        stroke="#2751CE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.5583 10.6662C19.3 10.5912 19.0333 10.5329 18.7583 10.4995C17.9583 10.3995 17.1916 10.4579 16.475 10.6662C16.7166 10.0495 17.3166 9.61621 18.0166 9.61621C18.7166 9.61621 19.3166 10.0495 19.5583 10.6662Z"
        stroke="#2751CE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5167 23.8838C20.5167 25.2588 19.3917 26.3838 18.0167 26.3838C17.3334 26.3838 16.7001 26.1005 16.2501 25.6505C15.8001 25.2005 15.5167 24.5671 15.5167 23.8838"
        stroke="#2751CE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  </div>
);
export default TedNotificationIcon;
